


























































































import Vue from 'vue'

export default Vue.extend({
  name: 'ScheduleAppointmentModal',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    brand: {
      type: String,
      required: true,
    },
    phoneNumber: {
      type: String,
      default: null,
    },
    scheduleUrl: {
      type: String,
      default: null,
    },
    offerDescription: {
      type: String,
      required: true,
    },
    minDaysBetweenOffer: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    called: false,
  }),
  computed: {
    rawPhoneNumber() {
      if (!this.phoneNumber) return ''
      return `tel:${this.phoneNumber.replace(/[^0-9]/g, '')}`
    },
    firstTip() {
      if (this.phoneNumber && !this.scheduleUrl) {
        return 'Tap the button below to call.'
      }
      if (!this.phoneNumber && this.scheduleUrl) {
        return 'Tap the button below to order online.'
      }
      if (this.phoneNumber && this.scheduleUrl) {
        return 'Select a schedule option below.'
      }
      return `Well this is embarrassing, we don't have a way to order, please try again in little bit`
    },
    isMultiple() {
      return this.phoneNumber && this.scheduleUrl
    },
  },
  methods: {
    callButtonPushed() {
      this.called = true
    },
  },
})
